import React, { useEffect, useMemo } from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_ANALYTICS_STATS } from "./graphql";

const TopServicesPanel = ({ filters }) => {
  const [fetchTop, { data, loading }] =
    useLazyQuery(GET_ANALYTICS_STATS);

  useEffect(() => {
    if (!filters.startDate || !filters.endDate) return;

    fetchTop({
      variables: {
        data: {
          ...filters,
          groupBy: "service",
          parentId: null,
        },
      },
      fetchPolicy: "network-only",
    });
  }, [filters]);

  const rows = data?.getServiceStats?.data || [];

  const total = useMemo(
    () =>
      rows.reduce(
        (sum, r) => sum + (r.totalCount || 0),
        0
      ),
    [rows]
  );

  return (
    <div className="bg-white p-6 rounded-xl shadow space-y-4">

      {/* Header */}
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-800">
          Top Services
        </h3>
        <span className="text-sm text-gray-500">
          {rows.length} services
        </span>
      </div>

      {loading ? (
        <div className="text-gray-500 text-sm">
          Loading...
        </div>
      ) : rows.length === 0 ? (
        <div className="text-gray-400 text-sm">
          No data available
        </div>
      ) : (
        <div className="flex flex-col divide-y">
          {rows.slice(0, 20).map((row, index) => {
            const percent =
              total > 0
                ? ((row.totalCount / total) * 100).toFixed(1)
                : 0;

            return (
              <div
                key={row.id}
                className="flex justify-between items-center py-3 hover:bg-gray-50 px-2 rounded transition"
              >
                {/* Left */}
                <div className="flex items-center gap-3">
                  <span className="text-sm text-gray-400 w-5">
                    {index + 1}
                  </span>
                  <div>
                    <p className="text-gray-800 text-sm font-medium">
                      {row.name}
                    </p>
                    <p className="text-xs text-gray-500">
                      {percent}% contribution
                    </p>
                  </div>
                </div>

                {/* Right */}
                <div className="text-right">
                  <p className="text-indigo-600 font-semibold text-sm">
                    {row.totalCount}
                  </p>
                  {row.revenue !== undefined && (
                    <p className="text-green-600 text-xs">
                      ₹ {row.revenue}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TopServicesPanel;